<template>
  <v-otp-input
    ref="input"
    class="zoox-component zoox-mfa-input"
    :type="type"
    :autofocus="autofocus"
    :value="value"
    :length="length"
    @finish="onFinish"
    @focus="onFocus"
    @input="onInput"
    @change="onChange"
  >
  </v-otp-input>
</template>

<script>
/**
 * @displayName Input MFA
 */
export default {
  name: 'ZMfaInput',
  props: {
    /**
     * Password/Number/Text
     */
    type: {
      type: String,
      default: 'number',
    },
    value: {
      type: String,
      required: true,
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    length: {
      type: Number,
      required: false,
      default: 4,
    },
    color: {
      type: String,
      default: 'var(--black-600)',
    },
    textColor: {
      type: String,
      default: 'var(--primary)',
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => this.focus())
    }
  },
  methods: {
    onInput(value) {
      /**
       * Evento emitido quando algum dos inputs são preenchidos
       *
       * @property {String} value - Valor digitado no input
       */
      this.$emit('input', value)
    },
    onFinish(value) {
      /**
       * Evento emitido quando todos os inputs são preenchidos
       *
       * @property {String} value - Valor digitado no input
       */
      this.$emit('finish', value)
      this.$emit('input', value)
    },
    onFocus() {
      /**
       * Evento disparado quando o input é focado
       */
      this.$emit('focus')
    },

    onChange(value) {
      /**
       * Evento disparado quando o input é alterado por interação do usuário
       *
       * @property {String} value - Valor digitado no input
       */
      this.$emit('change', value)
    },
    /**
     * @public - Método para focar o input
     */
    focus() {
      this.$refs.input.focus()
    },
  },
}
</script>

<style lang="scss">
.zoox-mfa-input:not(.error--text) {
  .v-input__slot {
    background: transparent !important;
  }
  .v-input__control {
    .v-input__slot:hover {
      fieldset {
        color: var(--primary) !important;
      }
    }
  }
}
</style>
